import React, { Fragment, useContext, useMemo } from 'react';
import Switch from "react-switch";

import SvgIcon from "../../SharedComponents/Icons";
import { Context } from "../index";
import MapWrapper from "./MapWrapper";

import './index.sass';


const MapSection = () => {

  const {
    coords,
    googleApiKey,
    hoveredPlaceId,
    mapIsOpen,
    setMapIsOpen,
    markers,
    isSuccess,
    boundsTrigger,
    setBoundsTrigger,
    setCoords,
    setPage,
    setRequestError,
    updateUrlParameters,
  } = useContext(Context);


  const updatedMarkers = useMemo(
    () => {
      const newMarkers = markers && markers.data && [ ...markers.data ];

      return newMarkers && newMarkers.map(marker => {
        const { id, lat, long } = marker.attributes;
        let ids = [];

        newMarkers.map(marker => {
          if (marker.attributes.id !== id && marker.attributes.lat === lat && marker.attributes.long === long) {
            ids.length ? ids.push(marker.attributes.id) : ids = [id, marker.attributes.id];
          };
        });

        ids.length && (marker.attributes.ids = ids);

        return marker;
      }, []);
    },
    [markers],
  );


  return (
    <Fragment>

      <div className="map-section__mobile-button" onClick={() => setMapIsOpen((prev) => !prev)}>
        <SvgIcon name={mapIsOpen ? "menu" : "map"} size={mapIsOpen ? 24 : 16} />
        <p>{ mapIsOpen ? "Vis liste" : "Vis kort" }</p>
      </div>

      <div className={`map-section__switch-button ${mapIsOpen ? 'open' : ''}`}>
        <label>
          <span>Vis på kort</span>
          <Switch
            onChange={setMapIsOpen}
            checked={mapIsOpen}
            uncheckedIcon={false}
            onHandleColor="#E8753D"
            offHandleColor="#444444"
            onColor="#FFFCF3"
            offColor="#FFFFFF"
            height={20}
            width={35}
            checkedIcon={false}
            className="list-view__switch"
          />
        </label>
      </div>

      { mapIsOpen &&
        <div className="map-section__map-container">
          <MapWrapper
            coords={coords}
            googleApiKey={googleApiKey}
            hoveredPlaceId={hoveredPlaceId}
            markers={updatedMarkers}
            isSuccess={isSuccess}
            boundsTrigger={boundsTrigger}
            setCoords={setCoords}
            setBoundsTrigger={setBoundsTrigger}
            setPage={setPage}
            setRequestError={setRequestError}
            updateUrlParameters={updateUrlParameters}
          />
        </div>
      }

    </Fragment>

  )
}

export default MapSection;
